import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { ICampaignAlterationRequestPayload } from "../types";

export function useCreateBrandCancellationRequest(briefId?: string, onSuccessCallback?: () => void) {
  const {
    mutate: createBrandCancellation,
    isLoading: isCreating,
    isSuccess: isCreated,
    error,
  } = useMutation({
    mutationFn: (payload: ICampaignAlterationRequestPayload) =>
      CampaignService.createAlterationRequest(payload).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg || "Failed to create brand cancellation request");
        throw err;
      }),
    options: {},
    onSuccess: () => {
      ToastService.success("Brand cancellation request created successfully");
      onSuccessCallback?.();
    },
  });

  return {
    createBrandCancellation,
    isCreating,
    isCreated,
    error,
  };
}
